import Cookies from 'js-cookie'
export const getUser=async ()=>{
    try{
    let token=Cookies.get(`${process.env.NODE_ENV}-userToken`);
    let user=JSON.parse(localStorage.getItem(`${process.env.NODE_ENV}-user`));
    
     if(token){
        let userData={name:user.name,email:user.email,img:user.img,permissions:user.permissions,role:user.role, 
            desingnation:user.desingnation,
            companyName:user.companyName,
            departmentName:user.departmentName,
            isHightAuthority: user.isHightAuthority
        }
        return new Promise((res,rej)=>{
            res(userData);
        })
    }
    else{
        localStorage.removeItem(`${process.env.NODE_ENV}-user`);
        return new Promise((res,rej)=>{
            rej({
                logout:true,
                message:""
            })
        })
    }
    }catch(e){
        if(e.response.status===403){
            localStorage.removeItem(`${process.env.NODE_ENV}-user`);
            sessionStorage.removeItem(`${process.env.NODE_ENV}-userToken`)
        }
        return new Promise((res,rej)=>{
            rej({
                logout:false,
                message:"Problem Occur! Please Try Again"
            })
        })
    }
}